import { render, staticRenderFns } from "./SimplePath.vue?vue&type=template&id=634952ea&"
import script from "./SimplePath.vue?vue&type=script&lang=ts&"
export * from "./SimplePath.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports